import "./EventVideoGeneratorDialog.scss";

import Dialog, {DialogCloseEventArgs} from "../1. Core/Controls/Dialog/Dialog";
import NP from "../1. Core/NP";
import {ServerAPI} from "../1. Core/ServerAPI";
import {EventTournament, IBattle, Stage, VideoFile} from "../10. Battle/types";

import BattleVideoGenerator from "./BattleVideoGenerator";
import Select from "../1. Core/Controls/Select/Select";
import Menu, {MenuItemArgs} from "../1. Core/Controls/Menu/Menu";
import Button from "../1. Core/Controls/Button/Button";
import Label from "../1. Core/Controls/Label/Label";
import {secondsToTime} from "../10. Battle/Util";
import TextField from "../1. Core/Controls/TextField/TextField";
import {HLEvent} from "./types";
import {getBattleMenuItems, showShareDialog} from "./func";


export default class EventVideoGeneratorDialog extends Dialog {
	private _Event: EventTournament;
	private _generators: BattleVideoGenerator[];
	private battleSelect: Select;

	private battleMenu: Menu;
	private menuBtn: Button;
	private battles: IBattle[];
	private lbl: Label;
	private _videoType: Select;
	private _timerLbl: Label;
	private _progressLabel: Label;
	private _streamTimeId: any;
	private startStreamDate: Date;
	private updateHLButton: Button;
	private _hlEventsItems: HLEvent[];

	_initFields(settings: object)
	{
		this._Event = null;
		super._initFields(settings);
		this._AutoDestroy = true;
		this._Caption = "Event Video Highlight Creator";
		this._ShowHeader = true;
		this._Mode = 'FullScreen';
		this._ShowButtons = false
	}

	_render()
	{
		super._render();
		this.setCaption(this._Event.Name);

		this.addClass('event-video-generator')

		NP.addCssClass(this._contentDomNode, 'dialog__surface--fullscreen');
		NP.addCssClass(this._container, 'dialog__container--fullscreen');

		this.getTopAppBar().addItem(this._timerLbl = new Label() as any, this._okButton);
		this._timerLbl.getRoot().style.color = 'black';
		this.getTopAppBar().addItem(this._progressLabel = new Label() as any, this._okButton);
		this._progressLabel.getRoot().style.color = 'black';

		this._okButton.setRK('StartCreateVideo');

		this.refresh();
	}

	async refresh()
	{

		let res = await ServerAPI.post('/battle/items', {
			"Offset": 0,
			"Count": 100,
			"EventId": this._Event.Id,
			"HideStat": true,
			"SortField": "StartTime",
			"SortDirection": 1
		}) as { List: IBattle[] }

		this.battles = res.List;

		this.createTab();

		this._generators = this.battles
			 .map((b, idx) => new BattleVideoGenerator({
				 Battle: b,
				 RoundPreview: false,
				 SuperWithoutPoint: false,
				 GridHeight: 370,
				 Height: this._Height - 64 - 70 - 40,
				 ParentNode: this._contentNode,
				 IsVisible: false,
				 EvVideoSettingsChanged: (fg: BattleVideoGenerator) =>
				 {
					 let v = fg.getPreviewType();
					 let addFirst = fg.getFirstPreviewVideo();
					 let addEnd = fg.getAddWallpaperToEnd();
					 this._generators.forEach(g =>
					 {
						 if (g != fg)
						 {
							 g.setPreviewType(v)
							 g.setFirstPreviewVideo(addFirst);
							 g.setAddWallpaperToEnd(addEnd);
						 }
					 })
				 }
			 }));
	}


	setHeight(value?: number, fireEvents?: boolean)
	{
		super.setHeight(value, fireEvents);
		this._generators?.forEach(b => b.setHeight(value - 64 - 70 - 40));
	}

	sortList(list: IBattle[])
	{
		return list.sort((a, b) =>
		{
			if (a.Stage == Stage.Maincard)
				return 1;

			if (b.Stage == Stage.Maincard)
				return -1;

			return 0;
		})
	}

	createTab()
	{
		this.menuBtn = new Button({
			ParentNode: this._contentNode,
			Class: 'app-button--raised',
			RK: 'ManageBattleList',
			Menu: this.battleMenu = new Menu({
				EvItemSelected: (s: object, e: MenuItemArgs) =>
				{
					e.IsCancelClose = true;
					e.Item.setIsChecked(!e.Item.getIsChecked())
					this.refreshBattleSelect()
					this._generators.forEach(g => g.setIsVisible(false));
				}
			})
		})


		this.battleMenu.addItems(getBattleMenuItems(this.battles))

		this.battleMenu.getItems().forEach(item => item.setIsChecked && item.setIsChecked(true))

		this.lbl = new Label({RK: 'SelectTheBattle', ParentNode: this._contentNode, Class: 'select-battle'})

		this.battleSelect = new Select({
			ParentNode: this._contentNode,
			Width: 300,
			SelectedIndex: 0,
			EvItemSelected: (s: object, e: { Item: { Value: number } }) =>
			{
				this._generators.forEach((g, idx) => g.setIsVisible(e.Item.Value == g.getBattle().Id))
				this.setHeight(this._Height)
			}
		});

		this.createVideoTypeSettings();
		this.refreshBattleSelect();


	}

	getSelectedBattles()
	{
		return this.battleMenu.getItems().filter(item => item.getIsChecked && item.getIsChecked()).map(item => item.getValue()) as IBattle[]
	}

	refreshBattleSelect()
	{
		this.battleSelect.setItems(this.getSelectedBattles().map((b, idx) => ({
			Value: b.Id,
			Content: b.RedName + ' vs ' + b.BlueName
		})));
	}

	async createVideoTypeSettings()
	{
		let node = NP.createNode(this._contentNode) as HTMLElement;
		node.style.display = 'inline-block';

		this._videoType = new Select({
			ParentNode: node,
			SelectedIndex: 0,
			Width: 200,
			Items: [{RK: 'None', Value: null},
				{Content: 'Full', Value: 'full'},
				{Content: 'Optimal', Value: 'optimal'}, {Content: 'Short', Value: 'short'}],
			EvItemSelected: () =>
			{
				let videoType = this._videoType.getValue();

				if (!videoType)
					return;

				let selectedBattles = this.getSelectedBattles();
				if (!selectedBattles.length)
					return;

				let generators = this._generators.filter(g => selectedBattles.find(sb => sb.Id == g.getBattle().Id))

				switch (videoType)
				{
					case 'optimal':
					case 'short':
					case 'full':
						generators.forEach(g => g.setVideoType(videoType));
						this.updateHLButton.setIsVisible(false)
						break;
					default:
						let hle = this._hlEventsItems.find(item => item.Id == videoType);
						if (hle)
						{
							generators.forEach(g => g.applyHLBattle(hle.HLBattles));
							this.updateHLButton.setIsVisible(true)
						}
						break;
				}
			}
		})

		this._videoType.getRoot().style.marginLeft = '12px';

		let svBtn = new Button({
			ParentNode: node,
			Class: 'app-button--raised',
			Content: 'Save',
			EvClick: () =>
			{
				(new Dialog({
					ShowHeader: true,
					Caption: 'Enter selection name',
					Content: new TextField({}),
					EvOkButtonClick: async (dlg: Dialog) =>
					{

						let selectedBattles = this.getSelectedBattles();
						if (!selectedBattles.length)
							return;

						let ids = [];

						for (let g of this._generators.filter(g => selectedBattles.find(sb => sb.Id == g.getBattle().Id)))
						{
							let bhlId = await g.saveToNewHL(dlg.getContent().getValue())
							ids.push(bhlId)
						}

						let newItem = {
							Name: dlg.getContent().getValue(),
							EventId: this._Event.Id,
							HLBattles: ids
						} as HLEvent

						newItem.Id = await ServerAPI.post(`/highlight/addHLEvent`, newItem)
						this._hlEventsItems.push(newItem)

						this._videoType.addItem({
							Content: newItem.Name,
							Value: newItem.Id
						})

						this._videoType.setValue(newItem.Id, false);
						this.updateHLButton.setIsVisible(true)
					}
				})).show()
			}
		})

		svBtn.getRoot().style.marginLeft = '12px';

		this.updateHLButton = new Button({
			ParentNode: node,
			Content: 'Update',
			Class: 'app-button--raised',
			EvClick: async () =>
			{
				let selectedBattles = this.getSelectedBattles();
				if (!selectedBattles.length)
					return;

				let item = this._hlEventsItems.find(i => i.Id == this._videoType.getValue());

				if (!item)
					return;

				item.HLBattles = [];

				for (let g of this._generators.filter(g => selectedBattles.find(sb => sb.Id == g.getBattle().Id)))
				{
					let bhlId = await g.updateHLBattle()
					if (!bhlId)
					{
						bhlId = await g.saveToNewHL(item.Name)
					}
					item.HLBattles.push(bhlId)
				}
			}
		})

		this.updateHLButton.getRoot().style.marginLeft = '12px';
		this.updateHLButton.setIsVisible(false)

		this._hlEventsItems = await ServerAPI.get<HLEvent[]>(`/highlight/getHLEventItems/${this._Event.Id}`)

		this._hlEventsItems.forEach(item =>
		{
			this._videoType.addItem({
				Content: item.Name,
				Value: item.Id
			})
		})
	}


	async _onOkButtonClick()
	{
		let selectedBattles = this.getSelectedBattles();
		if (!selectedBattles.length)
			return;

		(new Dialog({
			Content: new TextField({
				FloatingLabel: 'Enter name of the video',
			}),
			EvOkButtonClick: (dlg: Dialog, args: DialogCloseEventArgs) =>
			{
				let name = dlg.getContent().getValue().trim();
				if (name)
				{
					dlg.hide()
					this.doCreateVideo(name, selectedBattles)
				}
				else
					args.IsCancelClose = true
			}
		})).show()
	}

	async doCreateVideo(name: string, selectedBattles: IBattle[])
	{
		try
		{

			this._topAppBar.showWaiter()


			this.startStreamDate = new Date();
			this._streamTimeId = setTimeout(() => this.recalcDate(), 1000);
			setTimeout(() => this.recalcProgress(), 1000);
			this._timerLbl.setContent('00:00');

			let payload = this._generators.filter(g => selectedBattles.find(sb => sb.Id == g.getBattle().Id)).map(g => ({
				battleId: g.getBattle().Id,
				funnyList: g.getFunnyList(),
				rows: g.getSelectedActionList(),
				addPreviewVideo: g.getRoundPreviewVideo(),
				addFirstPreviewVideo: g.getFirstPreviewVideo(),
				compressAndSort: true,
				videoStartTime: g.getVideoWorldStartWorldTime(),
				videoType: g.getVideoType(),
				previewType: g.getPreviewType(),
				addWallpaperToEnd: g.getAddWallpaperToEnd(),
			}));

			let res = await ServerAPI.post<VideoFile>(`/video/createEventVideo/${this._Event.Id}?videoType=${this._videoType.getValue()}&name=${name}`, payload);

			showShareDialog(res)

		} finally
		{
			this.startStreamDate = null;
			this._topAppBar.hideWaiter();
		}
	}

	async recalcDate()
	{
		if (this.startStreamDate)
		{
			let t = new Date().getTime() - this.startStreamDate.getTime();
			this._timerLbl.setContent(secondsToTime(t / 1000));

			this._streamTimeId = setTimeout(() => this.recalcDate(), 800);
		}
	}

	async recalcProgress()
	{
		let info = await ServerAPI.get<{ message: string }>(`/video/getCreateHLProgress/${this._Event.Id}`)
		if (info)
		{
			this._progressLabel.setContent(' ' + info.message)
			setTimeout(() => this.recalcProgress(), 1000);
		}
		else
			this._progressLabel.setContent('')
	}
}
